export enum InvoiceSource {
    Import = 'Import',
    Manual = 'Manual',
    InternalTransfer = 'InternalTransfer',
    PartiallyDistribution = 'PartiallyDistribution',
    InvoiceAttribution = 'InvoiceAttribution',
}
